export const qcBotItems = [
  {
    id: 1,
    parentText: "Active Learning",
    text: "Active Learning",
    name: "Active Learning",
    path: "/qcbot",
    onClick: () => {
      //navigate("/");
    },
  },
  
];

export const sideBotItems = [
  {
    id: 1,
    parentText: "QC Bot",
    text: "Side 1",
    name: "Pallet Review",
    path: "/qcbot",
    onClick: () => {
      //navigate("/");
    },
  },
  {
    id: 2,
    parentText: "QC Bot",
    text: "Side 2",
    name: "Pallet Archive",
    path: "/palletarchive",
    onClick: () => {
      //navigate("/");
    },
  },
  {
    id: 3,
    parentText: "QC Bot",
    text: "Side 3",
    name: "Pallet Archive",
    path: "/palletarchive",
    onClick: () => {
      //navigate("/");
    },
  },
  {
    id: 4,
    parentText: "QC Bot",
    text: "Side 4",
    name: "Pallet Archive",
    path: "/palletarchive",
    onClick: () => {
      //navigate("/");
    },
  },
];

export const loadValidationItems = [
  {
    id: 3,
    parentText: "Load Validation",
    text: "Dock Door Controls",
    name: "Dock Door Controls",
    path: "/dockdoorcontrol",
    onClick: () => {
      //navigate("/");
    },
  },
];
export const expressDeliveryItems = [
    {
        id: 11,
        parentText: "Express Delivery",
        text: "Email Management",
        name: "Email Management",
        path: "/emailmanagement",
        onClick: () => {
            //navigate("/");
        },
    },
];
export const warehouseInsightItems = [
  
  
];

export const deliveryInsights = [
  
  
  

];
